import React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../../../utils';
import { withTheme } from 'styled-components';
import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
import { Theme } from '../../../models/Theme';
import {
    ChildReferenceComponent,
    ChildReferenceProps,
} from '../../../utils/accessibility/ChildReferenceComponent';

const StyledButton = styled<any, any>(
    'button',
    'styledButton',
    'dropdownButton'
)`
    ${propStyles};
    cursor: pointer;
`;

StyledButton.defaultProps = {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    padding: 'sm',
    fontSize: 'sm',
    fontFamily: 'body',
    fontWeight: 'normal',
    color: 'body',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    hover: {
        borderColor: 'gray500',
    },
    selected: {
        color: 'body',
        borderColor: 'gray500',
    },
};

interface Props<THtmlInstance> extends ChildReferenceProps<THtmlInstance> {
    isFocused: boolean;
    onBlur: (e) => void;
    onClick: (e) => void;
    onKeyDown: (e) => void;
    onKeyUp: (e) => void;
    ariaLabel: string;
    dataSelected: boolean;
    dataMetricId: string;
    theme?: Theme;
}

@inject('dataStore')
@observer
class DropdownButton extends ChildReferenceComponent<
    Props<HTMLButtonElement>,
    HTMLButtonElement
> {
    get shouldApplyFocus() {
        return this.props.isFocused;
    }

    get renderProps() {
        const { ariaLabel, dataMetricId, dataSelected } = this.props;

        return {
            'aria-label': ariaLabel,
            'data-selected': dataSelected,
            'data-metric-id': dataMetricId,
            ...this.interactiveProps,
        };
    }

    render() {
        const { children, theme, ...props } = this.props;

        return (
            <StyledButton
                {...this.renderProps}
                {...theme.DropdownButton}
                {...props}
            >
                {children}
            </StyledButton>
        );
    }
}

export default withTheme(DropdownButton);



// WEBPACK FOOTER //
// ./src/Components/Dropdown/Components/DropdownButton.tsx